import { getCoreFollowedSlice } from './get';

import { postCoreFollowSlice, postCoreUnfollowSlice } from './post';

export const { requestGetCoreFollowed, resetGetCoreFollowed } =
	getCoreFollowedSlice.asyncActionCreators;

export const { requestPostCoreFollow, resetPostCoreFollow } =
	postCoreFollowSlice.asyncActionCreators;

export const { requestPostCoreUnfollow, resetPostCoreUnfollow } =
	postCoreUnfollowSlice.asyncActionCreators;

export * from './_idMap/actions';
export * from './all/actions';
